export { default } from './ForecastGraphsSunlightTable';
